<div class="container my-5">
  <mat-card>
    <mat-card-content>
      <form [formGroup]="simulationForm" (ngSubmit)="onUpdate()">
        <!-- Campo per il titolo -->
        <div class="form-group">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Titolo</mat-label>
            <input matInput placeholder="Inserisci il titolo" formControlName="name" required>
            <mat-error *ngIf="simulationForm.get('name')?.hasError('required')">
              Il titolo è obbligatorio.
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Campo per la descrizione -->
        <div class="form-group mt-3">
          <app-rich-text-editor
            formControlName="description"
            [placeholder]="'Inserisci la descrizione della simulazione'"
            [isPreview]="false">
          </app-rich-text-editor>
        </div>

        <!-- Gestione degli allegati -->
        <div class="form-group mt-5">
          <app-attachment-manager
            [attachments]="attachments"
            [allowedAttachmentTypes]="['FILE', 'PUBMED']"
            [uploadUrl]="'upload/tmp-proposal-file'"
            (attachmentsChange)="onAttachmentsChange($event)">
          </app-attachment-manager>
        </div>

        <!-- Pulsanti per Reset e Aggiornamento -->
        <div class="d-flex justify-content-end mt-4">
          <button mat-raised-button color="warn" type="button" class="mr-2" (click)="resetForm()" [disabled]="!isChanged">
            {{ "generic.cancel" | translate }}
          </button>
          <button mat-raised-button color="primary" type="submit" [disabled]="simulationForm.invalid || loading">
            {{ "generic.buttons.update" | translate }}
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
